module.exports = __webpack_public_path__ + "static/lifewheel-cyan-50115ed66e490ba8fe6e38ccf830cdad.png";